/* eslint-disable no-useless-escape */
export const toCamelCase = value =>
  value.toLowerCase().replace(/(\-\w)/g, matches => matches[1].toUpperCase());

export const normalizeColorName = color => toCamelCase(color.replace('@', ''));

export const getShortString = (str, countOfSymbols) => {
  const eos = '...';
  if (typeof str !== 'string') {
    return str;
  }
  let strLength = str.length;
  if (strLength <= countOfSymbols) {
    return str;
  }
  return `${str.substr(0, countOfSymbols)}${eos}`;
};

export const getSizeString = size => {
  var sizeStr = '';
  if (!size || size < 1024) {
    return '0 Kb';
  }
  if (size < 1024 * 1024) {
    sizeStr = (size / 1024).toFixed(2);
    return `${sizeStr} Kb`;
  }
  sizeStr = (size / (1024 * 1024)).toFixed(2);
  return `${sizeStr} MB`;
};

export const isMeaningful = value => !!(value && value.trim().length > 0);
